import { Badge } from '@optools/components/ui/badge';
import { cn } from '@optools/components/ui/utils';
import { TargetView } from '@optools/services/operator-gateway/types/generated/graphql';

const statusColorMap: Record<TargetView['status'], string> = {
  bad: 'bg-red-500 text-white hover:bg-red-500',
  channel_disabled: 'bg-gray-700 text-white hover:bg-gray-700',
  disabled: 'bg-gray-700 text-white hover:bg-gray-700',
  good: 'bg-green-600 text-black hover:bg-green-600',
  no_channel: 'bg-sky-900 text-white hover:bg-sky-900',
  pending: 'bg-sky-900 text-white hover:bg-sky-900',
  warning: 'bg-amber-500 text-black hover:bg-amber-500',
};

export interface TargetStatusProps {
  status: TargetView['status'];
}

export function TargetStatus({ status }: TargetStatusProps) {
  const colorClass = statusColorMap[status];

  return <Badge className={cn(colorClass)}>{status}</Badge>;
}
